import React from 'react';
import { Button, Table, Spinner, Alert, Badge, Card, Row, Col } from 'react-bootstrap';
import { FaSync, FaDownload, FaArrowLeft } from 'react-icons/fa';
import FacebookV2API from '../../api/FacebookV2API';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';

class FacebookLeads extends React.Component {
  state = {
    inApiCall: false,
    integrationId: null,
    formName: '',
    pageName: '',
    leads: [],
    stats: { pulled: 0, duplicates: 0, errors: 0 },
    error: null,
    pulled: false,
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('integrationId');
    if (id) {
      this.setState({ integrationId: id }, () => this.loadIntegrationDetails());
    } else {
      Util.showError('No form ID provided');
    }
  }

  loadIntegrationDetails = () => {
    FacebookV2API.getIntegrationDetails(
      this.state.integrationId,
      (data) => {
        console.log({loadIntegrationDetails: data});
        this.setState({
          formName: data.form_name,
          pageName: data.page_name,
        });
        this.triggerPull(data.access_token, data.form_id);
      },
      (err) => {
        Util.showError('Failed to load form details: ' + err);
        this.setState({ error: err });
      }
    );
  };

  triggerPull = (pageAccessToken, formId) => {
    this.setState({ inApiCall: true });
    FacebookV2API.pullLeads(
      { page_access_token: pageAccessToken, form_id: formId },
      (response) => {
        this.setState({
          leads: response.leads || [],
          stats: response.stats || {},
          pulled: true,
          inApiCall: false,
        });
      },
      (err) => {
        this.setState({ error: err, inApiCall: false });
        Util.showError('Lead pull failed: ' + err);
      }
    );
  };

  render() {
    const { leads, stats, inApiCall, pulled, formName, pageName, integrationId } = this.state;

    if (!integrationId) {
      return <Alert variant="warning">No form specified. Please go back and select a form.</Alert>;
    }

    return (
      <div style={{ padding: '24px', backgroundColor: '#f5f7fb', minHeight: '100vh' }}>
        <Card style={{ borderRadius: '16px', border: 'none', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
          <Card.Header style={{ background: 'linear-gradient(135deg, #1877f2, #4361ee)', color: 'white', padding: '24px' }}>
            <Row>
              <Col>
                <h4>Today's Leads</h4>
                <p className="mb-0">
                  Form: <strong>{formName}</strong> | Page: <strong>{pageName}</strong>
                </p>
              </Col>
              <Col className="text-end d-flex align-items-center justify-content-end">
                <Button variant="light" size="sm" href="/setting/third-party/facebook">
                  <FaArrowLeft className="me-2" /> Back to Integrations
                </Button>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            {!pulled && !inApiCall && (
              <div className="text-center py-4">
                <Button variant="primary" onClick={() => this.loadFormDetails()}>
                  <FaSync className="me-2" /> Start Pull
                </Button>
              </div>
            )}
            {inApiCall && (
              <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2">Pulling leads for today...</p>
              </div>
            )}
            {pulled && (
              <>
                <Row className="mb-4">
                  <Col><Badge bg="success">Pulled: {stats.pulled}</Badge></Col>
                  <Col><Badge bg="warning">Duplicates: {stats.duplicates}</Badge></Col>
                  <Col><Badge bg="danger">Errors: {stats.errors}</Badge></Col>
                </Row>
                {leads.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead className="table-light">
                      <tr>
                        <th width="5%">#</th>
                        <th width="15%">Created</th>
                        <th width="70%">Fields &amp; Values</th>
                        <th width="10%">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leads.map((lead, idx) => (
                        <tr key={lead.id}>
                          <td className="align-top">{idx + 1}</td>
                          <td className="align-top text-nowrap">{new Date(lead.created_time).toLocaleString()}</td>
                          <td>
                            {lead.field_data && lead.field_data.length > 0 ? (
                              <table className="table table-sm table-borderless mb-0">
                                <tbody>
                                  {lead.field_data.map((field, i) => (
                                    <tr key={i}>
                                      <td style={{ fontWeight: 600, whiteSpace: 'nowrap', paddingRight: '12px', width: '40%' }}>
                                        {field.name}
                                      </td>
                                      <td>
                                        {field.values ? field.values.join(', ') : '—'}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <span className="text-muted">No fields available</span>
                            )}
                          </td>
                          <td className="align-top">
                            {lead.is_duplicate ? (
                              <Badge bg="warning">Duplicate</Badge>
                            ) : (
                              <Badge bg="success">New</Badge>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <Alert variant="info">No leads found for today.</Alert>
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default withRouter(FacebookLeads);